import { useSetAtom } from "jotai";
import { useEffect } from "react";

import {
  useGetBookingAnalyticsMetadata,
  useGetBookingAnalyticsMetadata_booking$key,
} from "@/screens/BookingDetail/NewPatronBookingFlow/hooks/useGetBookingAnalyticsMetadata";

import { bookingSummaryAnalyticsDataAtom } from "./bookingSummaryAnalyticsDataAtom";

export const useInitializeBookingSummaryAnalyticsDataAtom = (
  bookingRef: useGetBookingAnalyticsMetadata_booking$key | null
) => {
  const analyticsData = useGetBookingAnalyticsMetadata(bookingRef);
  const setBookingSummaryAnalyticsDataAtom = useSetAtom(
    bookingSummaryAnalyticsDataAtom
  );
  useEffect(() => {
    setBookingSummaryAnalyticsDataAtom(analyticsData);
  }, [analyticsData, setBookingSummaryAnalyticsDataAtom]);
};
